import { Injectable } from '@angular/core';
import {CanActivate, Router, UrlTree} from '@angular/router';
import {UserModel} from '../user/user.model';
import {UserActions} from '../user/user.actions';
import {AuthorizationUtils} from '../utils/authorization.utils';

@Injectable({
  providedIn: 'root'
})
export class AdminGuardService implements CanActivate {

  constructor() { }

  canActivate(): boolean | UrlTree {
    const user: UserModel = UserActions.userGetLocalStorage();
    return AuthorizationUtils.isAdmin(user);
  }
}
